import React from 'react';
import { lifecycle, compose, withState } from 'recompose';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { getFbPageIdSelector } from '@mm/state/selectors/viewSelectors';
import SendToMessenger from '../../../../../../common/components/facebook-plugin-components/SendToMessenger/SendToMessenger';
import {
  APP_ID,
  PAGE_ID,
  REF,
} from '../../../../../../common/constants/checkboxPluginConfig';
import facebookSDKActions from '@mm/state/actions/facebookActions';
import {
  SafeTimeout,
  withSafeTimeout,
} from '../../../../../../common/hocs/withSafeTimeout';
import './CompleteRegisterButton.pcss';
import { LifeCycleThis } from '@mm/utils';
import { StoreState } from '@mm/state/store-interfaces';

// TODO: Add checkboxPluginConfig items as environment vars

type StateProps = {
  facebookReady: boolean;
  sendToMessengerRendered: boolean;
};

type StateHandlers = {
  setFacebookReady: (change: boolean) => void;
  setSendToMessengerRendered: (change: boolean) => void;
};

type OuterProps = {
  disabled: boolean;
  isMobileApp: boolean;
  onSentToMessenger: () => any;
  buttonName: string;
  className?: string;
};

type InnerProps = ReturnType<typeof mapStateToProps> &
  StateHandlers &
  StateProps & { safeTimeout: SafeTimeout };

type Props = OuterProps & InnerProps;

const CompleteRegisterButton = (props: Props) => {
  const {
    env,
    fbPageId,
    disabled,
    facebookReady,
    isMobileApp,
    onSentToMessenger,
    sendToMessengerRendered,
    setSendToMessengerRendered,
    buttonName = 'Get Started',
    className,
  } = props;

  const fbAppId = IS_PROD ? APP_ID : env.fbAppId;
  const localFbPageId = IS_PROD ? PAGE_ID : fbPageId;

  // 20200522/GE: Temporarily disable the send-to-messenger functionality in onboarding.
  // Old condition on subsequent line.
  const showMessengerButton = false;
  // fbAppId && localFbPageId && facebookReady && !isMobileApp;

  // Show fallback button when other button is not rendered.
  // We place the fallback button on top of iFrame. Only if we remove the 'rendered'
  // event will we remove the fallback button.
  const showFallbackButton = !showMessengerButton || !sendToMessengerRendered;

  const classList = classnames('complete-register-button', className, {
    'complete-register-button--disabled': disabled,
  });

  return (
    <div className={classList}>
      {showMessengerButton && (
        <SendToMessenger
          appId={fbAppId}
          pageId={localFbPageId}
          passthroughParams={REF}
          onOptIn={onSentToMessenger}
          onRendered={() => setSendToMessengerRendered(true)}
          size="large"
        />
      )}

      {showFallbackButton && (
        <div
          className="complete-register-button__fallback-button"
          onClick={() => onSentToMessenger()}
        >
          {buttonName}
        </div>
      )}
    </div>
  );
};

async function componentDidMount(this: LifeCycleThis<Props>) {
  const { setFacebookReady } = this.props;

  try {
    await facebookSDKActions.getFacebookSDK();
  } catch {}
  setFacebookReady(true);
}

const mapStateToProps = (state: StoreState) => ({
  env: state.env,
  fbPageId: getFbPageIdSelector(state),
});

const enrichComponent = compose<InnerProps, OuterProps>(
  withSafeTimeout,
  connect(mapStateToProps),
  withState('facebookReady', 'setFacebookReady', false),
  withState('sendToMessengerRendered', 'setSendToMessengerRendered', false),
  lifecycle<Props, {}>({ componentDidMount }),
);

export default enrichComponent(CompleteRegisterButton);
